module.exports = __webpack_public_path__ + "img/sidemenu-close.34d50a63.png";